const Config = function () {
  // The values in this object will be the default config values,
  // and will be overriden with the values (of the same keys)
  // defined in the secrets.json file.
  const config = {
    serverWs: 'wss://devagent.greenbureau.com/asgi/agents',
    serverHttp: 'https://devagent.greenbureau.com/api'
  }

  try {
    // This tries to load the secret configs. In the event that the
    // file is missing, we will just get an empty object.
    let secrets
    if (process.env.NODE_ENV === 'production') {
      secrets = require('./prod.json')
    } else {
      secrets = require('./dev.json')
    }

    // Override default config with values from the secrets file.
    Object.assign(config, secrets)
  } catch (e) {

  }
  return config
}

const config = Config()
export default config
